import React, { useState } from "react";
import styles from "../../Styles/Playlist/playlist.module.css";

const Creators = ({ filters, creators, handleFilters }) => {
  const [checked, setChecked] = useState([]);

  const handleToggle = (c) => () => {
    const currentCreatorId = checked.indexOf(c);
    const newCheckedCreatorId = [...checked];

    if (currentCreatorId === -1) {
      newCheckedCreatorId.push(c);
    } else {
      newCheckedCreatorId.splice(currentCreatorId, 1);
    }

    setChecked(newCheckedCreatorId);
    handleFilters(newCheckedCreatorId);
  };

  return (
    <>
      <ul>
        {creators.map((creator, index) => {
          return (
            <>
              <li className={styles.list} key={index}>
                <input
                  type="checkbox"
                  onChange={handleToggle(creator._id)}
                  value={checked.indexOf(creator._id === -1)}
                  checked={
                    filters ? filters.creator.includes(creator._id) : false
                  }
                />
                {creator.name}
              </li>
            </>
          );
        })}
      </ul>
    </>
  );
};

export default Creators;
